import { render, staticRenderFns } from "./PosMain.vue?vue&type=template&id=a9fd9a60"
import script from "./PosMain.vue?vue&type=script&lang=js"
export * from "./PosMain.vue?vue&type=script&lang=js"
import style0 from "./PosMain.vue?vue&type=style&index=0&id=a9fd9a60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports